app.controller('BrowseCommonDevWindowAcquiredController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.printTags = function () {
        let tagsString = "";
        if ($scope.develop_acquired_choice) {
            const sourceObject = $scope.develop_acquired_choice.source_object;
            if (sourceObject) {
                const tags = sourceObject.tags;
                if (tags) {
                    for (let i = 0; i < tags.length; i++) {
                        if (tagsString) {
                            tagsString += ", ";
                        }
                        tagsString += tags[i];
                    }

                }
            }
        }
        return tagsString ? tagsString : "No tags";
    }

    function acquiredChoiceJSON() {
        const object = {};
        if ($scope.develop_acquired_choice) {
            const sourceObject = $scope.develop_acquired_choice.source_object;
            object.acquiredObject = sourceObject ? sourceObject : null;
            const developAcquiredChoiceClone = JSON.parse(JSON.stringify($scope.develop_acquired_choice));
            delete developAcquiredChoiceClone.source_object;
            const navigationIDs = $scope.navigation_ids;
            const cache = {}
            if (navigationIDs.base_component_id) {
                cache.component = $rootScope.service.cache_local_server.getComponentObject(navigationIDs.base_component_id, navigationIDs.parent_category_group_id, navigationIDs.parent_category_id, navigationIDs.alpha_category_id, true, true);
            }

            if (navigationIDs.site_range_id) {
                const siteRange = $rootScope.model.cache_local_server.site_range.choices[navigationIDs.site_range_id];
                if (siteRange) {
                    cache.site_range = siteRange;
                    if (navigationIDs.colour_id) {
                        if (navigationIDs.colour_id) {

                            const cacheColours = $rootScope.model.cache_local_server.colour.site_range[navigationIDs.site_range_id];
                            const colour = cacheColours ? cacheColours.choices[navigationIDs.colour_id] : null;
                            if (colour) {
                                cache.colour = colour;
                            }
                        }
                    }
                    if (navigationIDs.style_id) {
                        if (navigationIDs.style_id) {

                            const cacheStyles = $rootScope.model.cache_local_server.style.site_range[navigationIDs.site_range_id];
                            const style = cacheStyles ? cacheStyles.choices[navigationIDs.style_id] : null;
                            if (style) {
                                cache.style = style;
                            }
                        }
                    }
                }
            }
            object.cache = cache;
            object.siteObject = developAcquiredChoiceClone;
        }

        return JSON.stringify(object)
    }

    $scope.printAcquiredChoice = function () {

        const form = document.createElement("form");
        form.method = "post";
        form.action = "/request/print-request.php";
        form.target = "_blank";

        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", "print_json");
        input.setAttribute("value", acquiredChoiceJSON());
        form.appendChild(input);

        const body = document.body;
        body.appendChild(form);


        form.submit();
        body.removeChild(form);
    }

}]);